import { accountDetails, http } from "@di";
import actions from "./action";
import presenters from "./presenters";
import repositories from "./repositories";
import useCases from "./useCases";
const cRepositorires = repositories(http, accountDetails);
const cUseCases = useCases(cRepositorires);
const cActions = actions();
const cPresenters = presenters(cUseCases, cActions);
export default {
    postLogin: cPresenters.postLogin,
};
